module.exports = __webpack_public_path__ + "img/classic_m8.50ae269b.png";